(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabUpdateScriptsDetailController', TabUpdateScriptsDetailController);

    TabUpdateScriptsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabUpdateScripts', 'DataUtils'];

    function TabUpdateScriptsDetailController($scope, $rootScope, $stateParams, entity, TabUpdateScripts, DataUtils) {
        var vm = this;
        vm.tabUpdateScripts = entity;

        var unsubscribe = $rootScope.$on('jotApp.tabUpdateScriptsUpdate', function (event, result) {
            vm.tabUpdateScripts = result;
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();
